/**@flow */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import * as employeeSelectors from "@modules/employee/selectors";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@components";
import { SchemaForm } from "@components";
import uiSchema from "./__ui__/schema";

type PropsFromState = $Exact<{
  isLoading: boolean,
}>;

type Props = $Exact<{
  ...PropsFromLocalize,
  ...PropsFromState,
  onDismissHandler: Function,
  onSubmit: Function,
  schema: Object,
}>;
type State = $Exact<{
  formData: ?Object,
}>;

export class AddMedicationModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }
  state = {
    formData: null,
  };

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (form: Object) => {
    this.props.onSubmit(form);
  };

  handleChange = (formData: Object) => {
    this.setState({
      ...this.state,
      formData: formData,
    });
  };

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader toggle={this.props.onDismissHandler}>
          {this.props.t("ADD_MEDICATION")}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            className="w-100"
            formData={this.state.formData || {}}
            schema={this.props.schema || {}}
            onSubmit={this.handleSubmit}
            onChange={this.handleChange}
            uiSchema={uiSchema}
            noValidate={true}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button onClick={this.submitForm}>{this.props.t("ADD_MEDICATION")}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: employeeSelectors.isLoading(state),
});

export default connect(mapStateToProps)(localize()(AddMedicationModal));
